import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Gleap from 'gleap';
import './App.css';
import Router from './router';
import { GLEAP_NETWORK_BLACKLIST } from './gleap-config';
import tokenService from './utils/tokenService';
import AppErrorBoundary from './components/error-boundary/AppErrorBoundary';

let gleapInitialized = false;

const App = () => {
  const isAuthenticated = useSelector((state) => state.authReducer.isAuthenticated);
  const user = useSelector((state) => state.authReducer.user);
  const roles = useSelector((state) => state.authReducer.roles);
  const selectedCompany = useSelector((state) => state.companyReducer.selected);

  useEffect(() => {
    const theme = tokenService.getTheme();
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
      document.body.classList.add('bg-slate-800');
    } else {
      document.documentElement.classList.remove('dark');
      document.body.classList.remove('bg-slate-800');
    }
  }, []);

  useEffect(() => {
    const key = process.env.REACT_APP_GLEAP_SDK_KEY;
    if (!key) return;

    if (isAuthenticated && user) {
      if (!gleapInitialized) {
        Gleap.initialize(key);
        Gleap.setNetworkLogsBlacklist(GLEAP_NETWORK_BLACKLIST);
        Gleap.setLanguage('en');
        Gleap.hideAiChatbar();
        gleapInitialized = true;
      }
      Gleap.identify(String(user.id), {
        name:
          user.fullname ||
          user.name ||
          [user.firstname, user.lastname].filter(Boolean).join(' ') ||
          user.email,
        email: user.email,
        companyId: selectedCompany?.id ? String(selectedCompany.id) : undefined,
        companyName: selectedCompany?.name || undefined,
        customData: {
          roles: Array.isArray(roles) ? roles.join(',') : '',
        },
      });
    } else if (gleapInitialized) {
      Gleap.clearIdentity();
    }
  }, [isAuthenticated, user, roles, selectedCompany]);

  return (
    <AppErrorBoundary>
      <Router />
    </AppErrorBoundary>
  );
};

export default App;
